/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */


// https://github.com/gatsbyjs/gatsby/issues/2940

import './src/config'
import React from 'react'
import { Router } from 'react-router-dom'
import { Provider } from 'mobx-react'
import stores from './src/stores'
import Crisp from './src/components/Crisp.Chat'

exports.replaceRouterComponent = ({ history }) => {
  return ({ children }) => (
    <Provider {...stores}>
      <Router history={history}>{children}</Router>
    </Provider>
  )
}

window.addEventListener('error', (e) => {
  window.gtag('event', 'exception', {
    description: e.message,
    location: `${e.filename}: ${e.lineno}`,
    fatal: true
  })
})

window.onerror = (message, file, lineNumber) => {
  window.gtag('event', 'exception', {
    description: message,
    location: `${file}:  ${lineNumber}`,
    fatal: true
  })
}


window.document.addEventListener('hoversignal.signalClose', (e) => {
  const signalId = e.detail.signalId;
  window.gtag('event', 'Signal Close', { event_category: 'HoverSignal', event_label: signalId })
});

window.document.addEventListener('hoversignal.signalDidShow', (e) => {
  const signalId = e.detail.signalId;
  console.log('signalDidShow')
  window.gtag('event', 'Signal Did Show', { event_category: 'HoverSignal', event_label: signalId })
});



// WEBPACK FOOTER //
// ./gatsby-browser.js